<template>
    <div class="custom-box">
        <div class="w-11/12 xl:w-4/5 mx-auto py-6 sl:py-10">
            <div class="circle-step-section flex items-center pb-6 mb-5 border-b border-gray-300">
                <div class="font-medium rounded-full flex flex-col justify-center items-center text-brand-100 text-lg md:text-2xl border-2 border-solid border-brand-100 bg-brand-900 w-16 h-16 lg:w-72 lg:h-72 leading-tight">1 <div class="text-sm">Step</div></div>
                <div class="ml-8">
                    <h2 class="text-xl lg:text-3xl 2xl:text-4xl text-blue-100 font-bold mb-1">Select a product form</h2>
                    <!-- <p class="text-gray-200 text-xs md:text-lg hidden md:block">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> -->
                </div>
            </div>
            <div class="px-4 pt-0 pb-6 lg:pb-10">
                <div class="w-4/5 mx-auto">
                    <div class="md:flex md:items-center">
                        <div class="">
                            <label
                                class="pr-4 tracking-wide block text-gray-200 text-xs sm:text-sm md:text-base font-medium"
                                for="inline-full-name"
                            >
                                Select Product Form/Concentration
                            </label>
                        </div>
                        <div class="lg:flex-1 w-full md:w-4/5 lg:w-auto mx-auto shrink mt-4 lg:mt-0">
                            <div class="relative">
                                <select
                                    class="select_input appearance-none btn-large w-full bg-white border border-grey-lighter text-grey-darker pr-8 leading-tight focus:outline-none focus:border-grey cursor-pointer"
                                    id="grid-state"
                                    :value="product"
                                    @change="productSelected"
                                >
                                    <option v-for="option in productOptions" :key="option.name">{{ option.name }}</option>
                                </select>
                                <div class="arrow_select pointer-events-none absolute inset-y-0 pin-r flex items-center px-2 text-grey-darker">
                                    <svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.49997 10C8.1953 10 7.89066 9.87995 7.65837 9.64036L0.348741 2.09719C-0.116247 1.61736 -0.116247 0.839379 0.348741 0.359734C0.813541 -0.119911 1.56729 -0.119911 2.03231 0.359734L8.49997 7.03435L14.9677 0.359967C15.4327 -0.119678 16.1863 -0.119678 16.6511 0.359967C17.1163 0.839612 17.1163 1.61759 16.6511 2.09743L9.34157 9.6406C9.10917 9.88022 8.80453 10 8.49997 10Z" fill="#808080"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="field-label-left is-normal">
                        <label class="label">Select Product Form/Concentration</label>
                    </div>
                    <div class="field-body">
                        <div class="field is-expanded">
                            <div class="control">
                                <div class="select is-fullwidth">
                                    <select
                                        v-model="productForm"
                                        @change="productSelected"
                                    >
                                        <option>HiPhos 10.000 GT</option>
                                        <option>HiPhos 20.000 GT</option>
                                        <option>HiPhos 20.000 L</option>
                                        <option>HiPhos 50.000 M</option>
                                        <option>HiPhos 65.000 L</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <div
            class="column is-8 is-offset-2 notification is-danger has-text-centered"
            v-if="showProductError"
        >
            Please select the Product Form that you wish to use
        </div>
    </div>
</template>
<script>
export default {
    props: ["selectedProductVersion", "animal", "product"],
    data() {
        return {
            showProductError: false,
            products: [
                {
                    name: "HiPhos 5,000 GT",
                    productVersion: 'hiphos',
                    animalsExcluded: ['Aqua']
                },
                {
                    name: "HiPhos 10,000 GT",
                    productVersion: 'hiphos',
                    animalsExcluded: []
                },
                {
                    name: "HiPhos 20,000 GT",
                    productVersion: 'hiphos',
                    animalsExcluded: []
                },
                {
                    name: "HiPhos 20,000 L",
                    productVersion: 'hiphos',
                    animalsExcluded: []
                },
                {
                    name: "HiPhos 50,000 M",
                    productVersion: 'hiphos',
                    animalsExcluded: ['Aqua']
                },
                {
                    name: "HiPhos 50,000 L",
                    productVersion: 'hiphos',
                    animalsExcluded: []
                },
                {
                    name: "HiPhorius10 (10,000 FYT/g)",
                    productVersion: 'hiphorius',
                    animalsExcluded: []
                },
                {
                    name: "HiPhorius40 (40,000 FYT/g)",
                    productVersion: 'hiphorius',
                    animalsExcluded: []
                },
                {
                    name: "HiPhorius20 (L) (20,000 FYT/g)",
                    productVersion: 'hiphorius',
                    animalsExcluded: []
                },
                {
                    name: "HiPhorius50 (L) (50,000 FYT/g)",
                    productVersion: 'hiphorius',
                    animalsExcluded: []
                },
            ]
        };
    },
    created() {
        EventHub.$on("invalidProduct", () => {
            this.showProductError = true;
        });
    },
    methods: {
        productSelected: function(ev) {
            this.$emit("update:product", ev.target.value);
        }
    },
    computed: {
        productOptions() {
            return _.filter(this.products, (product) => {
                return product.productVersion === this.selectedProductVersion && !_.includes(product.animalsExcluded, this.animal)
            })
        }
    }
};
</script>
<style type="text/css">
.field-label-left {
    flex: 0 0 50%;
    text-align: left;
}

.card {
    border-radius: 5px;
}
</style>
